import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "next-i18next";
import { CoimexButton } from "../Card/Button";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { useRouter } from "next/router";
import { CoimexIcon } from "../../../pages/pricing";

function createData(name, [calories, fat, carbs, protein], ali) {
  return { name, calories, fat, carbs, protein, ali };
}
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    height: 20,
    paddingLeft: "32px",
    paddingRight: "32px",
  },
  tableCell: {
    padding: "0px 10px",
  },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    height: 20,
  },
}))(TableRow);

export default function CoimexNewTable(props) {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const classes = useStyles();
  const [rowsData, setRowsData] = useState([]);
  const type = router.query.package;
  const que = type === "importer" ? t("Price.10") : t("Price.11");
  const offer = type === "importer" ? t("Price.24") : t("Price.8");
  const productSupport = (data) =>
    props.data.map((item, key) =>
      item.duration.type === props.value ? item?.quota.newSupport[data] : null
    );

  console.log("Props", props);

  const product = (data) =>
    props.data.map((item, key) =>
      item.duration.type === props.value
        ? data === "posts"
          ? item?.quotaText.posts
          : item?.quota[data]
        : null
    );

  const rowsExporter = [
    createData(
      t("Price.9"),
      product("categories").filter((item) => item),
      t("Price.36")
    ),

    createData(
      offer,
      product("posts").filter((item) => item),
      t("Price.37")
    ),
    //

    createData(
      que,
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.38")
    ),

    createData(
      t("Price.12"),
      product("regionsAndCountries").filter((item) => item),
      t("Price.39")
    ),

    createData(
      t("Price.13"),
      product("instantOpportunityNotifications").filter((item) => item),
      t("Price.40")
    ),

    createData(
      t("Price.14"),
      product("coiwallAccess").filter((item) => item),
      t("Price.41")
    ),

    createData(
      t("Price.15"),
      product("nonMemberTrustVerification"),
      t("Price.42")
    ),
  ];
  const rowsImporter = [
    createData(
      t("Price.9"),
      product("categories").filter((item) => item),
      t("Price.28")
    ),

    createData(
      offer,
      product("posts").filter((item) => item),
      t("Price.29")
    ),
    //
    createData(
      t("Price.26"),
      product("messagingProductPosts").filter((item) => item),
      t("Price.30")
    ),
    createData(
      que,
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.31")
    ),

    createData(
      t("Price.12"),
      product("regionsAndCountries").filter((item) => item),
      t("Price.32")
    ),

    createData(
      t("Price.13"),
      product("instantOpportunityNotifications").filter((item) => item),
      t("Price.33")
    ),

    createData(
      t("Price.14"),
      product("coiwallAccess").filter((item) => item),
      t("Price.34")
    ),

    createData(
      t("Price.15"),
      product("nonMemberTrustVerification"),
      t("Price.35")
    ),
  ];
  const rowsBoth = [
    createData(
      t("Price.9"),
      product("categories").filter((item) => item),
      t("Price.43")
    ),
    createData(
      t("Price.26"),
      product("messagingProductPosts").filter((item) => item),
      t("Price.46")
    ),
    createData(
      t("Price.24"),
      product("posts").filter((item) => item),
      t("Price.45")
    ),
    createData(
      t("Price.8"),
      product("posts").filter((item) => item),
      t("Price.43")
    ),

    createData(
      t("Price.10"),
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.47")
    ),
    createData(
      t("Price.11"),
      product("replyingProductPostsMessages").filter((item) => item),
      t("Price.44")
    ),
    createData(
      t("Price.12"),
      product("regionsAndCountries").filter((item) => item),
      t("Price.48")
    ),
    createData(
      t("Price.13"),
      product("instantOpportunityNotifications").filter((item) => item),
      t("Price.49")
    ),

    createData(
      t("Price.14"),
      product("coiwallAccess").filter((item) => item),
      t("Price.50")
    ),
    createData(
      t("Price.15"),
      product("nonMemberTrustVerification").filter((item) => item),
      t("Price.51")
    ),
  ];

  const rowsNewExporter = [
    createData(
      t("NewPrice.20"),
      product("tradeGuarantee").filter((item) => item),
      t("Price.43")
    ),

    // createData(
    //   offer,
    //   product("posts").filter((item) => item),
    //   t("Price.37")
    // ),
    createData(
      t("NewPrice.21"),
      product("productCategory").filter((item) => item),
      t("Price.30")
    ),

    // createData(
    //   que,
    //   product("replyingProductPostsMessages").filter((item) => item),
    //   t("Price.38")
    // ),

    createData(
      t("NewPrice.22"),
      product("escrowSafePaymentFees").filter((item) => item),
      t("Price.32")
    ),
    createData(
      t("NewPrice.23"),
      product("promptPayAssurance").filter((item) => item != null),
      t("Price.43")
    ),

    createData(
      t("NewPrice.24"),
      product("systemUsage").filter((item) => item),
      t("Price.33")
    ),

    // createData(
    //   t("Price.14"),
    //   product("coiwallAccess").filter((item) => item),
    //   t("Price.41")
    // ),

    // createData(
    //   t("Price.15"),
    //   product("nonMemberTrustVerification"),
    //   t("Price.42")
    // ),
  ];
  const rowsNewImporter = [
    createData(
      t("NewPrice.20"),
      product("tradeGuarantee").filter((item) => item),
      t("Price.43")
    ),

    // createData(
    //   offer,
    //   product("posts").filter((item) => item),
    //   t("Price.29")
    // ),

    createData(
      t("NewPrice.21"),
      product("productCategory").filter((item) => item),
      t("Price.30")
    ),
    // createData(
    //   que,
    //   product("replyingProductPostsMessages").filter((item) => item),
    //   t("Price.31")
    // ),

    createData(
      t("NewPrice.22"),
      product("escrowSafePaymentFees").filter((item) => item),
      t("Price.32")
    ),

    createData(
      t("NewPrice.24"),
      product("systemUsage").filter((item) => item),
      t("Price.33")
    ),

    // createData(
    //   t("Price.14"),
    //   product("coiwallAccess").filter((item) => item),
    //   t("Price.34")
    // ),

    // createData(
    //   t("Price.15"),
    //   product("nonMemberTrustVerification"),
    //   t("Price.35")
    // ),
  ];

  const rowsNewBoth = [
    createData(
      t("NewPrice.20"),
      product("tradeGuarantee").filter((item) => item),
      t("Price.43")
    ),
    createData(
      t("NewPrice.21"),
      product("productCategory").filter((item) => item),
      t("Price.46")
    ),
    createData(
      t("NewPrice.22"),
      product("escrowSafePaymentFees").filter((item) => item),
      t("Price.45")
    ),
    createData(
      t("NewPrice.23"),
      product("promptPayAssurance").filter((item) => item !== null),
      t("Price.43")
    ),

    createData(
      t("NewPrice.24"),
      product("systemUsage").filter((item) => item),
      t("Price.47")
    ),
    // createData(
    //   t("Price.11"),
    //   product("replyingProductPostsMessages").filter((item) => item),
    //   t("Price.44")
    // ),
    // createData(
    //   t("Price.12"),
    //   product("regionsAndCountries").filter((item) => item),
    //   t("Price.48")
    // ),
    // createData(
    //   t("Price.13"),
    //   product("instantOpportunityNotifications").filter((item) => item),
    //   t("Price.49")
    // ),

    // createData(
    //   t("Price.14"),
    //   product("coiwallAccess").filter((item) => item),
    //   t("Price.50")
    // ),
    // createData(
    //   t("Price.15"),
    //   product("nonMemberTrustVerification").filter((item) => item),
    //   t("Price.51")
    // ),
  ];
  const offerSupport = type === "importer" ? t("Price.25") : t("Price.18");
  const SupportDef = [
    createData(
      t("NewPrice.26"),
      productSupport("matchmakingAndDealSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.27"),
      productSupport("nonMemberVerification").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.28"),
      productSupport("opportunityAndPostSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.29"),
      productSupport("tradeShowMetingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.30"),
      productSupport("marketingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.31"),
      productSupport("strategicSupport").filter((item) => item != null)
    ),
    // createData('Customer Acquisition Guarantee', productSupport("COIWALL").filter((item)=>item!= null)),
  ];
  const Supportexport = [
    createData(
      t("NewPrice.26"),
      productSupport("matchmakingAndDealSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.27"),
      productSupport("nonMemberVerification").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.28"),
      productSupport("opportunityAndPostSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.29"),
      productSupport("tradeShowMetingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.30"),
      productSupport("marketingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.31"),
      productSupport("strategicSupport").filter((item) => item != null)
    ),
  ];
  const SupportBoth = [
    createData(
      t("Price.16"),
      productSupport("technical").filter((item) => item != null)
    ),
    createData(
      t("Price.17"),
      productSupport("dealNegotiation").filter((item) => item != null)
    ),
    createData(
      t("Price.18"),
      productSupport("productPost").filter((item) => item != null)
    ),
    createData(
      t("Price.25"),
      productSupport("productPost").filter((item) => item != null)
    ),
    createData(
      t("Price.19"),
      productSupport("coiwall").filter((item) => item != null)
    ),
    createData(
      t("Price.20"),
      productSupport("marketing").filter((item) => item != null)
    ),
    createData(
      t("Price.21"),
      productSupport("strategicForeignTrade").filter((item) => item != null)
    ),
    // createData('Customer Acquisition Guarantee', productSupport("COIWALL").filter((item)=>item!= null)),
  ];

  const NewSupportBoth = [
    createData(
      t("NewPrice.26"),
      productSupport("matchmakingAndDealSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.27"),
      productSupport("nonMemberVerification").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.28"),
      productSupport("opportunityAndPostSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.29"),
      productSupport("tradeShowMetingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.30"),
      productSupport("marketingSupport").filter((item) => item != null)
    ),
    createData(
      t("NewPrice.31"),
      productSupport("strategicSupport").filter((item) => item != null)
    ),
    // createData(
    //   t("Price.21"),
    //   productSupport("strategicForeignTrade").filter((item) => item != null)
    // ),
    // createData('Customer Acquisition Guarantee', productSupport("COIWALL").filter((item)=>item!= null)),
  ];
  function handleType() {
    switch (type) {
      case "importer":
        return rowsNewImporter;
      case "exporter":
        return rowsNewExporter;
      default:
        return rowsNewBoth;
    }
  }
  function handleSupport() {
    switch (type) {
      case "importer":
        return SupportDef;
      case "exporter":
        return Supportexport;
      default:
        return NewSupportBoth;
    }
  }
  const rows = handleType();
  const Support = handleSupport();
  return (
    <TableContainer className="bg-textColor rounded-[16px] hidden md:block lg:block xl:block">
      <Table className="w-full table-auto sm:hidden md:block lg:block xl:block">
        <TableHead className="w-full">
          <TableRow sx={{ border: "none" }}>
            <TableCell className="center text-[#38466D] !border-0 !pb-0 px-11">
              <h4 className="text-[#38466D] !border-0 text-xl font-MontserratSemiBold">
                Features
              </h4>
            </TableCell>
            <TableCell className="text-[#38466D] !border-0 !pb-0 text-[24px] font-MontserratBold ">
              <h4 className="text-[#38466D] text-xl font-MontserratSemiBold">
                Details
              </h4>
            </TableCell>
            {props.data.map(
              (item, key) =>
                item.duration.type === props.value && (
                  <TableCell key={key} align="center !border-0 !pb-0">
                    <h4 className="text-[#38466D] text-xl font-MontserratSemiBold">
                      {t(`Price.${item?.type}`)}
                    </h4>
                  </TableCell>
                )
            )}
          </TableRow>
        </TableHead>
        <TableBody
          className="w-full"
          sx={{
            "&>tr:nth-child(2)": { backgroundColor: "#EBEBF0" },
          }}
        >
          <TableRow sx={{ border: "none" }} className="w-full ">
            <TableCell className="text-[#38466D] !border-0"></TableCell>
            <TableCell className="text-[#38466D] !border-0"></TableCell>
            {type === "importer" && (
              <TableCell className="text-[#38466D] !border-0 !pt-1">
                <p className="text-base font-semibold text-[#000] font-montserrat">
                  {t("NewPrice.46")}
                </p>
                <p className="text-base font-normal text-[#000] font-montserrat">
                  {t("NewPr@ice.49")}
                </p>
              </TableCell>
            )}
            <TableCell className="text-[#38466D] !border-0 !pt-1">
              <p className="text-base font-semibold text-[#000] font-montserrat">
                {t("NewPrice.46")}
              </p>
              <p className="text-base font-normal text-[#000] font-montserrat">
                {t("NewPrice.49")}
              </p>
            </TableCell>
            <TableCell className="text-[#38466D] !border-0 !pt-1">
              <p className="text-base font-semibold text-[#000] font-montserrat">
                {t("NewPrice.47")}
              </p>
              <p className="text-base font-normal text-[#000] font-montserrat">
                {t("NewPrice.50")}
              </p>
            </TableCell>
            <TableCell className="text-[#38466D] !border-0 !pt-1">
              <p className="text-base font-semibold text-[#000] font-montserrat">
                {t("NewPrice.48")}{" "}
              </p>

              <p className="text-base font-normal text-[#000] font-montserrat">
                {t("NewPrice.51")}
              </p>
            </TableCell>
          </TableRow>

          <TableRow className="bg-[#EBEBF0] w-full">
            {/* Static Empty Cells */}
            <TableCell className="text-[#38466D] text-xl font-MontserratBold"></TableCell>
            <TableCell className="text-[#38466D] text-xl font-MontserratBold"></TableCell>

            {/* Dynamic Cells */}
            {props.data
              .filter((item) => item.duration.type === props.value)
              .map((item, key) => (
                <TableCell key={key} align="left">
                  <div className="flex flex-col items-center gap-2 w-[180px] pt-1 pb-4 ">
                    {/* Price Section */}
                    <p className="text-base text-[#38466D] font-MontserratBold font-bold">
                      <span className="text-base font-MontserratBold font-bold">
                        ${item?.price}
                      </span>{" "}
                      {props.value === "Biannually" ? t("Price.54") : " / "}
                      {props.value === "Biannually"
                        ? t("Price.53")
                        : t("Price.23")}
                    </p>
                    {type === "importer" && item.type === "Freemium" ? (
                      <>
                        {/* Alternative Payment Section (Placeholder for alignment) */}
                        <p className="text-base text-[#38466D] font-MontserratBold font-bold text-center opacity-0">
                          Or {/* Placeholder text, hidden */}
                        </p>
                        <p className="text-base text-[#38466D] font-MontserratBold font-bold text-center opacity-0">
                          Or {/* Placeholder text, hidden */}
                        </p>

                        <div className="flex flex-col w-[173px] items-start opacity-0">
                          {/* Placeholder div for alignment */}
                          <div className="flex gap-1 items-center">
                            <CoimexIcon />
                            {/* Removed icon to avoid visual clutter */}
                            <p className="leading-[20px] text-base text-[#38466D] font-bold font-MontserratBold">
                              {/* {t("NewPrice.44")} {t("NewPrice.11")} */}{" "}
                              {/* Removed text to avoid visual clutter */}
                            </p>
                          </div>

                          {/* Second Line */}
                          <div className="flex flex-col items-start w-full pl-3 opacity-0">
                            <p className="text-base text-[#38466D] font-bold font-MontserratBold">
                              {/* {t("NewPrice.58")} */}{" "}
                              {/* Removed text to avoid visual clutter */}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Alternative Payment Section */}
                        <p className="text-base text-[#38466D] font-MontserratBold font-bold text-center">
                          Or
                        </p>
                        <div className="flex flex-col w-[173px] items-start">
                          <div className="flex gap-1 items-center">
                            <CoimexIcon />
                            <p className="leading-[20px] text-base text-[#38466D] font-bold font-MontserratBold">
                              {t("NewPrice.44")} {t("NewPrice.11")}
                            </p>
                          </div>

                          {/* Second Line */}
                          <div className="flex flex-col items-start w-full pl-3">
                            <p className="text-base text-[#38466D] font-bold font-MontserratBold">
                              {t("NewPrice.58")}
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                    {/* Buy Now Button */}
                    {item.type === "Freemium" ? (
                      <button
                        className="w-full bg-[#38466D] capitalize h-[42px] rounded-full hover:bg-[#1f2a4b] text-white font-MontserratRegular font-bold text-base"
                        onClick={() => props.onClick(item)}
                      >
                        Signup Now
                      </button>
                    ) : (
                      <button
                        className="w-full bg-[#38466D] capitalize h-[42px] rounded-full hover:bg-[#1f2a4b] text-white font-MontserratRegular font-bold text-base"
                        onClick={() => props.onClick(item)}
                      >
                        {t("NewPrice.12")}
                      </button>
                    )}
                  </div>
                </TableCell>
              ))}

            {/* Placeholder Cells to Ensure Correct Column Count */}
            {Array(
              (type === "importer" ? 6 : 8) -
                props.data.filter((item) => item.duration.type === props.value)
                  .length
            )
              .fill(null)
              .map((_, i) => (
                <TableCell key={`placeholder-${i}`} />
              ))}
          </TableRow>

          {rows.map((row) => (
            <TableRow
              className={classes.tableRow}
              style={{
                height: "32px",
              }}
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { borderBottom: 0 } }}
            >
              <CoimexTooltip
                title={
                  <div className="bg-[#8791A7]">
                    <p className="text-white text-xs"> {row.ali}</p>
                  </div>
                }
              >
                <TableCell
                  component="th"
                  scope="row"
                  style={{ paddingLeft: "44px" }}
                >
                  <ul className="list-outside">
                    <li className=" md:w-auto list-disc text-[#38466D] capitalize text-base font-montserrat font-bold self-start">
                      {row.name}
                    </li>
                  </ul>
                </TableCell>
              </CoimexTooltip>

              <TableCell
                align="center"
                className="w-[267px] text-[#38466D] text-sm font-montserrat text-left font-normal "
              >
                {t("NewPrice.32")}
              </TableCell>

              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat  "
              >
                {typeof row.calories === "boolean" ? (
                  <ComSvg bol={row.calories} />
                ) : (
                  <ComTxt text={row.calories} />
                )}{" "}
                {row.name === t("NewPrice.20") ? (
                  type === "importer" ? (
                    t("NewPrice.60")
                  ) : (
                    t("NewPrice.38")
                  )
                ) : row.name === t("NewPrice.21") ? (
                  type === "importer" ? (
                    t("NewPrice.61")
                  ) : (
                    t("NewPrice.39")
                  )
                ) : row.name === t("NewPrice.22") ? (
                  <>
                    {t("NewPrice.37")}
                    <div className="flex flex-col items-center justify-center mt-2">
                      <p className="text-[#38466D] text-sm font-montserrat w-32 self-center">
                        ( {t("NewPrice.35")} )
                      </p>
                    </div>
                  </>
                ) : row.name === t("NewPrice.24") ? (
                  t("NewPrice.36")
                ) : null}
                {row.name === t("NewPrice.23") && (
                  <>
                    {""}
                    <div className="flex flex-col items-center justify-center mt-2">
                      <p className="w-[163px] text-[#38466D] text-sm font-montserrat self-center">
                        &nbsp;
                      </p>
                    </div>
                  </>
                )}
              </TableCell>
              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat "
              >
                {typeof row.fat === "boolean" ? (
                  <ComSvg bol={row.fat} />
                ) : (
                  <ComTxt text={row.fat} />
                )}{" "}
                {""}
                {row.name === t("NewPrice.20") ? (
                  row.fat < 2 ? (
                    type === "importer" ? (
                      t("NewPrice.60")
                    ) : (
                      t("NewPrice.38")
                    )
                  ) : type === "importer" ? (
                    t("NewPrice.61")
                  ) : (
                    t("NewPrice.59")
                  )
                ) : row.name === t("NewPrice.21") ? (
                  type === "importer" ? (
                    t("NewPrice.61")
                  ) : (
                    t("NewPrice.39")
                  )
                ) : row.name === t("NewPrice.22") ? (
                  <>
                    {t("NewPrice.37")}
                    <div className="flex flex-col items-center justify-center mt-2">
                      <p className="text-[#38466D] text-sm font-montserrat w-32 self-center">
                        ( {t("NewPrice.35")} )
                      </p>
                    </div>
                  </>
                ) : row.name === t("NewPrice.24") ? (
                  t("NewPrice.36")
                ) : null}
                {row.name === t("NewPrice.23") && row.fat && (
                  <div className="flex flex-col justify-center mt-2">
                    <p className="w-[163px] text-[#38466D] text-sm font-montserrat self-center">
                      ( {t("NewPrice.40")} )
                    </p>
                  </div>
                )}
              </TableCell>
              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat text-center"
              >
                {typeof row.carbs === "boolean" ? (
                  <ComSvg bol={row.carbs} />
                ) : (
                  <ComTxt text={row.carbs} />
                )}{" "}
                {row.name === t("NewPrice.20") ? (
                  row.carbs < 2 ? (
                    type === "importer" ? (
                      t("NewPrice.60")
                    ) : (
                      t("NewPrice.38")
                    )
                  ) : type === "importer" ? (
                    t("NewPrice.61")
                  ) : (
                    t("NewPrice.59")
                  )
                ) : row.name === t("NewPrice.21") ? (
                  type === "importer" ? (
                    t("NewPrice.61")
                  ) : (
                    t("NewPrice.39")
                  )
                ) : row.name === t("NewPrice.22") ? (
                  <>
                    {t("NewPrice.37")}
                    <div className="flex flex-col items-center justify-center mt-2">
                      <p className="text-[#38466D] text-sm font-montserrat w-32 self-center">
                        ( {t("NewPrice.35")} )
                      </p>
                    </div>
                  </>
                ) : row.name === t("NewPrice.24") ? (
                  t("NewPrice.36")
                ) : null}
                {row.name === t("NewPrice.23") && (
                  <div className="flex flex-col items-center justify-center mt-2">
                    <p className="w-[163px] text-[#38466D] text-sm font-montserrat self-center">
                      ( {t("NewPrice.40")} )
                    </p>
                  </div>
                )}
              </TableCell>
              {row.protein && (
                <TableCell
                  align="center"
                  className="text-[#38466D] text-base font-montserrat"
                >
                  {typeof row.protein === "boolean" ? (
                    <ComSvg bol={row.protein} />
                  ) : (
                    <ComTxt t={t} text={row.protein} />
                  )}{" "}
                  {row.name === t("NewPrice.20") ? (
                    row.protein < 2 ? (
                      type === "importer" ? (
                        t("NewPrice.60")
                      ) : (
                        t("NewPrice.38")
                      )
                    ) : type === "importer" ? (
                      t("NewPrice.61")
                    ) : (
                      t("NewPrice.59")
                    )
                  ) : row.name === t("NewPrice.21") ? (
                    type === "importer" ? (
                      t("NewPrice.61")
                    ) : (
                      t("NewPrice.39")
                    )
                  ) : row.name === t("NewPrice.22") ? (
                    <>
                      {t("NewPrice.37")}
                      <div className="flex flex-col items-center justify-center mt-2">
                        <p className="text-[#38466D] text-sm font-montserrat w-32 self-center">
                          ( {t("NewPrice.35")} )
                        </p>
                      </div>
                    </>
                  ) : row.name === t("NewPrice.24") ? (
                    t("NewPrice.36")
                  ) : null}
                  {row.name === t("NewPrice.23") && (
                    <p className="text-[#38466D] text-sm font-montserrat">
                      {t("NewPrice.40")}
                    </p>
                  )}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>

        <TableHead>
          <TableRow>
            <TableCell sx={{ border: "none", width: "200px" }}>
              <p className="text-[#38466D] md:w-auto text-xl font-MontserratBold whitespace-nowrap">
                {t("Price.22")}
              </p>
            </TableCell>
            <TableCell sx={{ border: "none" }} align="center"></TableCell>
            <TableCell sx={{ border: "none" }} align="center"></TableCell>
            <TableCell sx={{ border: "none" }} align="center"></TableCell>
            <TableCell sx={{ border: "none" }} align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Support.map((row) => (
            <TableRow
              className={classes.tableRow}
              style={{ height: "32px" }}
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <CoimexTooltip
                title={
                  <div className="bg-[#8791A7]">
                    <p className="text-white text-xs"> {row.name}</p>
                  </div>
                }
              >
                <TableCell component="th" scope="row" className="px-8">
                  <ul className="list-outside">
                    <li className="w-64 md:w-auto list-disc text-[#38466D] text-base font-bold font-montserrat">
                      {row.name}
                    </li>
                  </ul>
                </TableCell>
              </CoimexTooltip>
              <TableCell
                align="center"
                className="w-[267px] text-[#38466D] text-sm font-montserrat text-left font-normal"
              >
                {t("NewPrice.32")}
              </TableCell>
              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat"
              >
                {typeof row.calories === "boolean" ? (
                  <ComSvg bol={row.calories} />
                ) : (
                  row.calories
                )}
              </TableCell>

              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat"
              >
                {typeof row.fat === "boolean" ? (
                  <ComSvg bol={row.fat} />
                ) : (
                  row.fat
                )}
              </TableCell>
              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat"
              >
                {typeof row.carbs === "boolean" ? (
                  <ComSvg bol={row.carbs} />
                ) : (
                  row.carbs
                )}
              </TableCell>
              <TableCell
                align="center"
                className="text-[#38466D] text-base font-montserrat"
              >
                {typeof row.protein === "boolean" ? (
                  <ComSvg bol={row.protein} />
                ) : (
                  row.protein
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const ComSvg = ({ bol }) => {
  return bol ? <SvgTck /> : <SvgNon />;
};
const ComTxt = ({ text }) => {
  const { t } = useTranslation();

  function bol() {
    if (typeof text === "string") {
      if (text.includes("week")) {
        return text.replace("week", t(`Price.week`));
      } else if (text.includes("month")) {
        return text.replace("month", t(`Price.month`));
      }
      return t(`Price.${text}`);
    } else {
      return text;
    }
  }

  return isNaN(text) && !bol() ? t(`Price.${text}`) : bol();
};
const SvgTck = () => (
  <svg
    className="m-auto"
    width="19"
    height="12"
    viewBox="0 0 19 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3749 0.839371C18.534 0.95786 18.6295 1.12358 18.6405 1.3001C18.6514 1.47662 18.5768 1.64949 18.4332 1.7807L7.63258 11.6214L1.10176 6.48204C0.955117 6.35848 0.872417 6.1928 0.871109 6.01995C0.869802 5.84709 0.949988 5.68057 1.09475 5.55552C1.23952 5.43047 1.43754 5.35666 1.64705 5.34967C1.85656 5.34267 2.06117 5.40304 2.21773 5.51804L7.54686 9.71137L17.2339 0.886704C17.3052 0.821759 17.3913 0.769031 17.4873 0.731535C17.5834 0.694038 17.6874 0.672509 17.7935 0.668175C17.8996 0.663841 18.0057 0.676788 18.1058 0.706277C18.2058 0.735767 18.2978 0.781219 18.3766 0.840037L18.3749 0.839371Z"
      fill="#38466D"
      stroke="#38466D"
      strokeWidth="0.5"
    />
  </svg>
);

const SvgNon = () => (
  <svg
    className="m-auto"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75294 6.00003L12.0528 10.3692M1.45312 10.3692L6.75294 6.00003L1.45312 10.3692ZM12.0528 1.63086L6.75193 6.00003L12.0528 1.63086ZM6.75193 6.00003L1.45312 1.63086L6.75193 6.00003Z"
      stroke="#38466D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CoimexTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#8791A7",
    color: "#fff",
    maxWidth: 250,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));
